/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
// console.log(location.href)
let baseUrl = '';
let routerMode = 'hash';
let baseImgPath;

if (location.href.indexOf("ddyjapp.com") == -1) {
    console.log("localhost")
    // baseUrl = 'https://manage.ddyjapp.com/api-manage';
     baseUrl = 'http://manage.dingdingyijian.com/api-manage';
    // baseUrl = "http://localhost:8098/api-manage";
    baseImgPath = 'http://manage.dingdingyijian.com/api-manage';

} else {
    console.log("正式环境")
    baseUrl = 'https://manage.ddyjapp.com/api-manage';
    baseImgPath = 'https://manage.ddyjapp.com/api-manage';
}

export {
    baseUrl,
    routerMode,
    baseImgPath
}



// WEBPACK FOOTER //
// ./src/config/env.js